import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import { Box, Link as MuiLink } from '@mui/material';
import BackIcon from '@mui/icons-material/ChevronLeft';

import { Link } from '../Link';

interface BackButtonProps {
  backRoute: string;
  skipHistory?: boolean;
}

export const BackButton = ({ backRoute, skipHistory = false }: BackButtonProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const hasHistory = Boolean(location.key !== 'default');

  return (
    <Box display="flex" alignItems="center">
      {hasHistory && !skipHistory ? (
        <MuiLink
          sx={{
            cursor: 'pointer',
            textTransform: 'uppercase',
            fontWeight: (theme) => theme.typography.fontWeightMedium,
            letterSpacing: 0.5,
          }}
          display="flex"
          alignItems="center"
          gap={1}
          variant="body1"
          color="primary.main"
          underline="none"
          onClick={() => navigate(-1)}
        >
          <BackIcon /> {t('common.goBack')}
        </MuiLink>
      ) : (
        <Link
          sx={{
            cursor: 'pointer',
            textTransform: 'uppercase',
            fontWeight: (theme) => theme.typography.fontWeightMedium,

            letterSpacing: 0.5,
          }}
          display="flex"
          alignItems="center"
          gap={1}
          variant="body1"
          color="primary.main"
          underline="none"
          to={backRoute}
        >
          <BackIcon /> {t('common.goBack')}
        </Link>
      )}
    </Box>
  );
};
